import React from 'react';
import { PropertyGrid, Pane, NumericInput, TextInput, Label } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelTypeSelector } from '@leverege/ui-plugin';
import { Colorizers } from '@leverege/ui-attributes';
import { ns } from '@leverege/i18n';
import GlyphSymbolizer from "../../models/glyph/GlyphSymbolizer.js";
import TextGlyphModel from "../../models/glyph/TextGlyphModel.js";
const {
  t
} = ns('ui-attributes-graphs.editors.TextGlyphEditor');
export default function TextGlyphEditor(props) {
  const {
    value,
    objectType
  } = props;
  const onModelChange = useValueChange(TextGlyphModel, props);
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "glyphEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('size')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: TextGlyphModel.getFontSize(value),
    eventData: "setFontSize",
    onChange: onModelChange
  })), ModelTypeSelector.createSelectorAndEditor({
    modelKey: 'colorizer',
    values: Colorizers.getColorizersFor(objectType),
    value: TextGlyphModel.getStroke(value),
    eventData: 'setStroke',
    onChange: onModelChange,
    isPropertyGrid: true,
    label: t('color')
  }), ModelTypeSelector.createSelectorAndEditor({
    modelKey: 'symbolizer',
    values: GlyphSymbolizer.getSymbolizersFor(objectType),
    value: TextGlyphModel.getText(value),
    eventData: 'setText',
    onChange: onModelChange,
    allowNone: false,
    isPropertyGrid: true,
    label: t('text')
  }));
}